// extracted by mini-css-extract-plugin
export var alignCenter = "_9q-d";
export var bannerShown = "_9q-6";
export var buttonContent = "_9q-0";
export var cardList = "_9q-1";
export var centerContent = "_9q-2";
export var chevron = "_9q-3";
export var closePanelButton = "_9q-k";
export var conversationContextContainer = "_9q-l";
export var conversationDetailContainer = "_9q-4";
export var detailWrapper = "_9q-7";
export var dropdownButton = "_9q-e";
export var dropdownTitle = "_9q-9";
export var fullHeight = "_9q-5";
export var hidden = "_9q-a";
export var icon = "_9q-b";
export var mergeSuggestionWrapper = "_9q-m";
export var panel = "_9q-i";
export var portalButtonsWrapper = "_9q-c";
export var right = "_9q-j";
export var tableSummaryContainer = "_9q-8";
export var tableSummaryHeader = "_9q-g";
export var threeDotsButton = "_9q-f";
export var wide = "_9q-h";